module.exports = __webpack_public_path__ + "img/wochenblatt-33-jahre.5b7160df.jpg";